var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imgUrl)?_c('a',{staticClass:"aj-img-thumb",attrs:{"href":_vm.imgUrl,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.imgUrl},on:{"mouseenter":function($event){_vm.current = _vm.imgUrl},"mouseleave":function($event){_vm.current = null}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }